const API_BASE_URL = process.env.REACT_APP_RECRUIT_API_URL || 'http://localhost:8080';

async function getById(id) {
    const response = await fetch(`${API_BASE_URL}/api/recruitment-requests/${id}`);
    if (!response.ok) throw new Error('상세 정보를 불러오는데 실패했습니다.');
    return response.json();
}

async function getList({ status, jobCategoryCode, page = 0, size = 50 } = {}) {
    const url = new URL(`${API_BASE_URL}/api/recruitment-requests`);
    if (status) url.searchParams.set('status', status);
    if (jobCategoryCode) url.searchParams.set('jobCategoryCode', jobCategoryCode);
    url.searchParams.set('page', page);
    url.searchParams.set('size', size);

    const response = await fetch(url.toString());
    if (!response.ok) throw new Error('목록 조회에 실패했습니다.');
    return response.json();
}

async function getMyPosts(accessToken) {
    const response = await fetch(`${API_BASE_URL}/api/recruitment-requests/my`, {
        headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        const error = new Error(err.message || '내 구인글 조회에 실패했습니다.');
        error.status = response.status;
        throw error;
    }
    return response.json();
}

async function setActive(id, active, accessToken) {
    const response = await fetch(`${API_BASE_URL}/api/recruitment-requests/${id}/active`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify({ active }),
    });
    if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        const error = new Error(err.message || '상태 변경에 실패했습니다.');
        error.status = response.status;
        throw error;
    }
}

async function update(id, data, accessToken) {
    const response = await fetch(`${API_BASE_URL}/api/recruitment-requests/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        const error = new Error(err.message || '수정에 실패했습니다.');
        error.status = response.status;
        throw error;
    }
    return response.json();
}

async function deleteById(id, accessToken) {
    const response = await fetch(`${API_BASE_URL}/api/recruitment-requests/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        const error = new Error(err.message || '삭제에 실패했습니다.');
        error.status = response.status;
        throw error;
    }
}

export const recruitmentRequestRepository = {
    getList,
    getById,
    getMyPosts,
    setActive,
    update,
    deleteById,
    createRecruitmentRequest: async (data, accessToken) => {
        const headers = { 'Content-Type': 'application/json' };
        if (accessToken) headers['Authorization'] = `Bearer ${accessToken}`;
        const response = await fetch(`${API_BASE_URL}/api/recruitment-requests`, {
            method: 'POST',
            headers,
            body: JSON.stringify(data),
        });
        if (!response.ok) {
            const err = await response.json().catch(() => ({}));
            throw new Error(err.message || '채용 신청에 실패했습니다.');
        }
        return response.json();
    },
};
